module.exports = __webpack_public_path__ + "img/style8.9b4f98cd.png";